<template>
    <v-main class="ma-0 pa-0">

        <l-add-group-popup ref="l-add-group-popup"></l-add-group-popup>
        <l-edit-group-popup ref="l-edit-group-popup"></l-edit-group-popup>
        <l-add-key-popup ref="l-add-key-popup"></l-add-key-popup>
        <l-edit-key-popup ref="l-edit-key-popup"></l-edit-key-popup>
        <l-merge-key-popup ref="l-merge-key-popup"></l-merge-key-popup>

        <v-card elevation="0" outlined class="pa-2">
            <v-card-actions class="ma-0 pa-0 mt-0">
                <v-btn elevation="0" color="green" class="white--text" @click="addNewGroup" :disabled="!ifCanCreateNewGroup()">
                    New group
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn elevation="0" color="red" class="white--text" @click="fixLocaleKeys" :loading="fixLocalizations" :disabled="!ifCanAddMissingKeys()">
                    Add missing keys
                    <v-icon class="ml-2">mdi-auto-fix</v-icon>
                </v-btn>
                <v-btn elevation="0" color="orange" class="white--text" @click="exportAllLanguagesToServer" :loading="exportingXms" :disabled="!ifCanExport()">
                    Export ({{localizations.keys == null ? 0 :Object.keys(localizations.keys).length}} keys)
                    <v-icon class="ml-2">mdi-database-export</v-icon>
                </v-btn>
               <v-card elevation="0" outlined  class="ml-2">
                   <v-btn icon elevation="0" color="white" class="green--text" @click="exportAllLanguagesToJSON" :loading="exportingJSON" :disabled="!ifCanExportJSON()">
                       <v-icon color="green">mdi-file-export</v-icon>
                   </v-btn>
                   <input ref="uploaderJson"
                          class="d-none"
                          type="file"
                          accept="application/JSON"
                          @change="onFileChangedJson">
                   <v-btn icon elevation="0" color="white" class="red--text" @click="onPressImportJSON" :loading="importingJSON" :disabled="!ifCanImportJSON()">
                       <v-icon color="red">mdi-file-import</v-icon>
                   </v-btn>
               </v-card>
            </v-card-actions>
        </v-card>
        <v-card elevation="0" class="pa-2">
            <v-card-actions class="ma-0 pa-0 mt-0">
                <v-spacer></v-spacer>
                <v-btn icon elevation="0" @click="expand(false)">
                    <v-icon size="20">mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn icon elevation="0" @click="expand(true)">
                    <v-icon size="20">mdi-chevron-down</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card class="ma-0 pa-0">
                <v-card-actions class="ma-0 pa-0 mt-0" v-for="item in getItems" :key="item.key_id">
                    <template v-if="item.name != undefined">
                        <v-card elevation="0" outlined class="mt-2" width="100%" :color="item.color">
                            <v-card-actions class="ma-0 pa-0">
                                <v-btn icon color="white" class="ml-2" @click="addItemInGroup(item.group_id)" :disabled="!ifCanAddKeyValue()">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                <v-card-text class="white--text ml-1 pa-1">{{item.name}}</v-card-text>
                                <v-btn icon color="white" @click="showHide(item)">
                                    <v-icon v-if="hidden.includes(item.group_id)" size="20">mdi-chevron-down</v-icon>
                                    <v-icon v-else size="20">mdi-chevron-up</v-icon>
                                </v-btn>
                                <v-btn icon color="white" class="ml-0" @click="editGroup(item)" :disabled="!ifCanEditGroup()">
                                    <v-icon size="20">mdi-pencil-outline</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon color="white" class="mr-2" @click="deleteGroup(item.group_id)" :disabled="!ifCanDeleteGroup()">
                                    <v-icon size="20">mdi-delete</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-card width="40%" elevation="0">
                            <v-btn outlined
                                   width="100%"
                                   class="mt-1 no-uppercase"
                                   :color="getGroupColor(item.group_id)"
                                    @click="editKeyValue(item.group_id, item.key_id, item.key_name)">
                                {{item.key_name}}
                            </v-btn>
                        </v-card>
                        <v-card outlined
                                width="100%"
                                class="ma-0 ml-2 mt-1">
                            <v-card-actions>{{item.value}}</v-card-actions>
                        </v-card>
                    </template>
                </v-card-actions>
        </v-card>
    </v-main>
</template>

<script>

import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";
import LAddGroupPopup from "@/modules/mlocalization/views/popups/l-add-group-popup";
import LAddKeyPopup from "@/modules/mlocalization/views/popups/l-add-key-popup";
import LEditKeyPopup from "@/modules/mlocalization/views/popups/l-edit-key-popup";
import LEditGroupPopup from "@/modules/mlocalization/views/popups/l-edit-group-popup";
import {uuid} from "vue-uuid";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import JSZip from "jszip";
import {TimeUtils} from "@/common/TimeUtils";
import LMergeKeyPopup from "@/modules/mlocalization/views/popups/l-merge-key-popup";
import firebase from "firebase";

export default {
    name: "l-keys-list-view",
    components: {LMergeKeyPopup, LEditGroupPopup, LEditKeyPopup, LAddKeyPopup, LAddGroupPopup},
    props: ['language'],
    data: () => ({
        findKey:'',
        exportingXms:false,
        exportingJSON:false,
        importingJSON:false,
        fixLocalizations:false,
        hidden:[],
        importJson:[],
        savePaths:{},
    }),
    methods: {
        onPressImportJSON(){
            // window.addEventListener('focus', () => {
            // }, { once: false })
            // console.log("click->")
            this.$refs.uploaderJson.click()
        },
        onFileChangedJson(e) {
            this.importingJSON = true;
            e.target.files[0].text().then((data) => {
                let json = JSON.parse(data)

                if(json["language"] != this.language.name){
                    this.$notify({title: 'Wrong language!', text: "expected: "+ this.language.name, type: "error"});
                    return;
                }

                let groups = json["groups"]
                console.log("language: ", json["language"])
                console.log("groups: ", groups.length)

                this.importJson = [];
                this.savePaths = {};
                for (let k in groups){
                    let data = this.localizations
                    if (data != undefined){
                        for (let g in data.groups){
                            let group = data.groups[g];
                            if (group.group_id == groups[k].id){
                                if (group.name != groups[k].name){
                                    let key = "groups/" + groups[k].id +"/name";
                                    this.savePaths[key] = groups[k].name;
                                }
                                let oldColor = group.color;
                                if (oldColor.length == 9){oldColor = "#" + group.color.slice(3);}
                                if (oldColor.toLowerCase() != groups[k].color){
                                    let key = "groups/" + groups[k].id +"/color";
                                    this.savePaths[key] = groups[k].color;
                                }
                                if (group.order != groups[k].order){
                                    let key = "groups/" + groups[k].id +"/order";
                                    this.savePaths[key] = groups[k].order;
                                }
                            }
                        }
                    }
                    for (let key in groups[k]["keys"]){
                        let item = groups[k]["keys"][key];
                        for (let m in this.localizations.keys){
                            if(this.localizations.keys[m].key_name == item.key && this.localizations.keys[m].group_id != groups[k].id){
                                this.savePaths["keys/" + this.localizations.keys[m].key_id + '/group_id'] = groups[k].id;
                            }
                        }
                        this.importJson.push({"parced":false, "key":item.key, "value":item.value});
                    }
                }
                this.importingJSON = false;
                this.processImport();
            })
        },
        processImport(){
            let parced = this.importJson.filter(e=>e.parced != true)
            if (parced.length == 0 && this.savePaths != undefined) {
                console.log("COMPLETE ALL", this.savePaths);
                if (Object.keys(this.savePaths).length == 0){
                    this.$notify({title: 'No Changes', text:"", type: "succes"});
                    return;
                }
                LocalizationStoreUtils.updateKeys(this.savePaths)
                .then(() => {
                    this.$notify({title: 'Keys updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.fixLocalizations = false
                    this.$notify({title: 'Keys update failed!', text: error, type: "error"});
                })
                return;
            }
            let self = this;
            let getKey = function (needKey){
                for (let key_id in self.localizations.keys){
                    let value = self.localizations.keys[key_id][self.language.name]
                    if (self.localizations.keys[key_id].key_name == needKey){
                        return {"key_id":key_id, "old_value":value}
                    }
                }
                return null;
            }
            for (let key in this.importJson){
                let data = this.importJson[key];
                if (data.parced == false){
                     let responce = getKey(data.key);
                     if (responce != null){
                         if (responce.old_value == data.value){
                             this.importJson[key].parced = true;
                             self.processImport();
                             return;
                         }else{
                             this.$refs['l-merge-key-popup'].show(data.key, responce.old_value, data.value, (selectedValue) => {
                                 self.savePaths["keys/" + responce.key_id + '/' + self.language.name] = selectedValue;
                                 self.savePaths["keys/" + responce.key_id + '/owner'] = firebase.auth().currentUser.uid;
                                 self.importJson[key].parced = true;
                                 setTimeout(function() {
                                     self.processImport();
                                 }, 100)
                             })
                             return;
                         }
                     }else{
                         console.log(null, data.key)
                         this.importJson[key].parced = true;
                         self.processImport();
                         return;
                     }
                }
            }
        },
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanCreateNewGroup(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_NEW_GROUP.id)
        },
        ifCanAddMissingKeys(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_ADD_MISSING_KEYS.id)
        },
        ifCanExport(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_EXPORT.id)
        },
        ifCanExportJSON(){
            return true
        },
        ifCanImportJSON(){
            return true
        },
        ifCanAddKeyValue(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_ADD_KEY_VALUE.id)
        },
        ifCanEditGroup(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_EDIT_GROUP.id)
        },
        ifCanDeleteGroup(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.LOCALIZATION_TAB.subpermissions.LOCALIZATION_TAB_DELETE_GROUP.id)
        },
        expand(value){
            this.hidden = [];
            if (value == false){
                let data = this.localizations
                if (data != undefined){
                    for (let g in data.groups){
                        this.hidden.push(data.groups[g].group_id)
                    }
                }
            }
        },
        setSearchKey(key){
            this.hidden = [];
            this.findKey = key;
        },
        showHide(item){
            if (this.hidden.includes(item.group_id)){
                let index = this.hidden.indexOf(item.group_id)
                this.hidden.splice(index, 1)
            }else{
                this.hidden.push(item.group_id)
            }
        },
        fixLocaleKeys(){
            this.fixLocalizations = true
            LocalizationStoreUtils.getLocaleKeys()
                .then((keys) => {
                    var localKeys = []
                    for (let k in this.localizations.keys){
                        localKeys.push(this.localizations.keys[k].key_name)
                    }
                    var missingKeys = []
                    for (let k in keys[0]){
                        if (!localKeys.includes(keys[0][k])){
                            missingKeys.push(keys[0][k])
                        }
                    }
                    if (missingKeys.length == 0){
                        this.fixLocalizations = false
                        this.$notify({title: 'No keys to fix!', text: "", type: "succes"});
                    }else{
                        this.fixMissingKeys(missingKeys)
                    }
                })
                .catch((error) => {
                    //this.loading = null
                    console.log(error)
                    this.$notify({title: 'Fix group failed!', text: error, type: "error"});
                })
        },
        getMissingGroupId(){
            for (let g in this.localizations.groups){
                if (this.localizations.groups[g].name == "MISSING"){
                    return g
                }
            }
            return ""
        },
        fixMissingKeys(missingKeys){
            let data = []
            let missingGroupId = this.getMissingGroupId()
            if (missingGroupId != ""){
                for (let k in missingKeys){
                    console.log("notExistingKeys:", missingKeys[k])
                    let i = {
                        key_name: missingKeys[k],
                        key_id: uuid.v4().replace(/-/g, ""),
                        group_id: missingGroupId
                    }
                    i[this.language.name] = missingKeys[k]
                    data.push(i)
                }
                LocalizationStoreUtils.addKeys(data)
                .then(() => {
                    this.fixLocalizations = false
                    this.dialog = false
                    this.$notify({title: 'Items successfully added!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.fixLocalizations = false
                    this.$notify({title: 'Items add failed!', text: error, type: "error"});
                })
            }else{
                LocalizationStoreUtils.addGroup('MISSING', '#ff0000', 0)
                .then(() => {
                    this.fixMissingKeys(missingKeys)
                    this.$notify({title: 'New Group Created!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.fixLocalizations = false
                    this.$notify({title: 'New Group create failed!', text: error, type: "error"});
                })
            }
        },
        searchKey(findKey){
            //console.log("update: ",findKey )
            this.findKey = findKey
        },
        editGroup(group){
            this.$refs['l-edit-group-popup'].show(group)
        },
        getGroupColor(group_id){
            let data = this.localizations
            for (let g in data.groups){
                if (g == group_id){
                    return data.groups[g].color
                }
            }
            return ""
        },
        editKeyValue(group_id, key_id, key_name){
            this.$refs['l-edit-key-popup'].show(group_id, key_id, key_name, this.language)
        },
        addNewGroup(){
            this.$refs['l-add-group-popup'].show()
        },
        deleteGroup(id){
            this.$confirm("Are you sure?").then(() => {
                console.log('deleteGroup:', id)
                LocalizationStoreUtils.deleteGroup(id)
                .then(() => {
                    //this.loading = null
                    this.$notify({title: 'Group successfully deleted!', text: "", type: "succes"});
                })
                .catch((error) => {
                    //this.loading = null
                    this.$notify({title: 'Group delete failed!', text: error, type: "error"});
                })
            })
        },
        addItemInGroup(group_id){
            this.$refs['l-add-key-popup'].show(group_id, this.language)
        },
        generateXMLBody(language){
            let content = ""
            for (let group in this.localizations.groups){
                content += "<!--"+this.localizations.groups[group].name.toUpperCase()+"-->\n"
                for (let key in this.localizations.keys){
                    if(this.localizations.keys[key].group_id == group){
                        let value = this.localizations.keys[key][language.name]
                        if (value == undefined){value = this.localizations.keys[key].key_name}
                        content += '    <string name="'+this.localizations.keys[key].key_name+'">'+value+'</string>\n'
                    }
                }
            }

            return content
        },
        generateJSONBody(language){
            let content = {"groups":[], "language": language.name};
            for (let i in this.localizations.groups){
                let group = this.localizations.groups[i];
                var data = {"keys":[], "id":group.group_id, "name": group.name, "order": parseInt(group.order), "color": group.color};
                for (let key in this.localizations.keys){
                    if(this.localizations.keys[key].group_id == i){
                        let value = this.localizations.keys[key][language.name]
                        if (value == undefined){value = this.localizations.keys[key].key_name}
                        data["keys"].push({"key":this.localizations.keys[key].key_name, "value": value});
                    }
                }
                content["groups"].push(data);
            }
            return JSON.stringify(content);
        },
        exportAllLanguagesToJSON(){
            this.exportingJSON = true
            let JSZip = require("jszip");
            let zip = new JSZip();
            for (let tab in this.localizations.tabs){
                zip.file(this.localizations.tabs[tab].name + ".json", this.generateJSONBody(this.localizations.tabs[tab]));
            }
            let promise = zip.generateAsync({type : "blob"})
            promise.then((blob) => {
                let FileSaver = require('file-saver');
                FileSaver.saveAs(blob, "lang_"+TimeUtils.now()+".zip");
                this.exportingJSON = false
            })
            .catch((error) => {
                console.log("error:", error)
            })
        },
        exportAllLanguagesToServer(){
            this.exportingXms = true
            let JSZip = require("jszip");
            let zip = new JSZip();
            for (let tab in this.localizations.tabs){
                let content = this.generateXMLBody(this.localizations.tabs[tab])
                zip.file(this.localizations.tabs[tab].name + ".xml", "<resources>\n"+content+"</resources>");
            }
            let promise = zip.generateAsync({type : "blob"})
            promise.then((blob) => {
                LocalizationStoreUtils.uploadLocales(blob)
                .then(() => {
                    this.exportingXms = false
                    this.$notify({title: 'Locales successfully uploaded!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.exportingXms = false
                    this.$notify({title: 'Locales upload failed!', text: error, type: "error"});
                })
                //let FileSaver = require('file-saver');
                //FileSaver.saveAs(blob, "lang_"+TimeUtils.now()+".zip");
            })
            .catch((error) => {
                console.log("error:", error)
            })
        }
    },
    computed:{
        getItems(){
            let data = this.localizations
            if (data == undefined){return []}
            var groupsArray = []
            for (let g in data.groups){
                let ff = data.groups[g]
                ff.group_id = g
                if (ff.order == undefined){ff.order = 0}
                ff.hidden = true
                groupsArray.push(ff)
            }
            groupsArray = groupsArray.sort((a, b) => a.order - b.order);

            var items = []
            for (let g in groupsArray){

                let group_id = groupsArray[g].group_id
                items.push(groupsArray[g])
                if (this.hidden.includes(groupsArray[g].group_id)){continue}

                var tmp = [];
                for (let l in data.keys){
                    var key = data.keys[l];
                    if (key.group_id == group_id){
                        if (this.findKey == null || this.findKey.length == 0){
                            tmp.push({key_id:key.key_id, key_name:key.key_name, value: key[this.language.name], group_id:group_id})
                        }else{
                            if (key.key_name == undefined){
                                this.$notify({title: 'Undefined key: ' + l, text: "", type: "error"});
                            }
                            if (key.key_name != undefined && key.key_name.includes(this.findKey)){
                                tmp.push({key_id:key.key_id, key_name:key.key_name, value: key[this.language.name], group_id:group_id})
                            }
                            if (tmp.find(item => item.key_id === key.key_id) == undefined && key[this.language.name].length != 0 && key[this.language.name].includes(this.findKey)){
                                tmp.push({key_id:key.key_id, key_name:key.key_name, value: key[this.language.name], group_id:group_id})
                            }
                        }
                    }
                }

                tmp.sort(function(a, b) {
                    return a.key_name.localeCompare(b.key_name);
                });

                items = items.concat(tmp)
            }
            return items
        },
        localizations(){
            return LocalizationStoreUtils.getLocalizations()
        },
    }
}
</script>

<style scoped>
.no-uppercase {
    text-transform: none;
}
</style>